import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import SchemeTable from "../../components/Customer-scheme"

const Schemes = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Schemes | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <SchemeTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Schemes
